export default "__VITE_ASSET__fa01f70a__"